if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cartNotification = document.querySelector('cart-notification');
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if(this.form.classList.contains('product-form-restricted')) {
        kinetic.helpers.getDeviceCountryCode((countryCode) => {
          if (countryCode == "US") {
            this.handleRestrictedProduct();
          }
        });
      } else {
        this.handleRestrictedProduct()
      }
    }

    async handleRestrictedProduct() {
      const submitButton = this.querySelector('[type="submit"]');
      if (submitButton.classList.contains('loading')) return;

      //this.handleErrorMessage();
      this.cartNotification.setActiveElement(document.activeElement);

      submitButton.setAttribute('aria-disabled', true);
      submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      formData.append('sections', this.cartNotification.getSectionsToRender().map((section) => section.section));
      formData.append('sections_url', window.location.pathname);
      config.body = formData;
      const cartResponse = await fetch('/cart.js');
      const cartItems = await cartResponse.json();
      const currentItem = cartItems.items.find(item => String(item.id) === String(formData.get("id")));

      const prevQuantity = currentItem ? currentItem.quantity : 0;
      const formQuantity = parseInt(formData.get("quantity") || 1);
      let currentQuantity = formQuantity + parseInt(prevQuantity);
      let specialSet = this.dataset.specialSet;
      const quantityToAdd = (limit) => {
        currentQuantity = currentQuantity > limit ? 
          (currentQuantity > limit) && (prevQuantity < limit) ? 
          limit - prevQuantity : 0
          : formQuantity;
      }
      if (specialSet) {
        const SHOP_SPECIAL_SET_LINE_ITEM_LIMIT = 5;
        quantityToAdd(SHOP_SPECIAL_SET_LINE_ITEM_LIMIT);
      } else {
        const restrictedQty = parseInt(this.dataset.restrictedQty);
        const SHOP_REGULAR_LINE_ITEM_LIMIT = restrictedQty ? restrictedQty : 100;
        quantityToAdd(SHOP_REGULAR_LINE_ITEM_LIMIT);
      }
      formData.set("quantity", currentQuantity);
      
      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);
            return;
          }

          if(response.properties?._loyalty_birthday_gift) {
            window.disableBirthDayItem && disableBirthDayItem(true);
          }

          kinetic.helpers.renderCartLineItems && kinetic.helpers.renderCartLineItems();
          kinetic.ajaxCart.getCart();
          this.cartNotification.renderContents(response,formData.get('quantity'));
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          submitButton.classList.remove('loading');
          submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}
